import { Button, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  margin: {
    marginBottom: theme.spacing(2)
  }
}))

const SubmitButton = ({ onButtonClick }) => {
  const classes = useStyles()
  return (
    <Button
      className={classes.margin + ' link-button'}
      variant='contained'
      onClick={onButtonClick}
      size='large'
    >
      Lähetä
    </Button>
  )
}

export default SubmitButton
